export const blackListNames = ['default', 'selectors', 'defaultState'];

const createSelectors = (subSelectors, subtree) => {
    const selectors = {};
    const selectorNames = Object.keys(subSelectors).filter(
        name => subSelectors[name] instanceof Function && !blackListNames.includes(name),
    );
    selectorNames.forEach(name => {
        selectors[name] = (state, ...rest) => subSelectors[name](state[subtree], ...rest);
    });
    return selectors;
};

export default createSelectors;
